import { accountAxiosInstance } from "@/services/axios";

export const renewToken = async (params: { token: string }) => {
  const response = await accountAxiosInstance.post("/renew-token", params);
  return response.data;
};